<template>
  <div class="pages">
    <div class="top-tab">
      <van-popup
        v-model="show"
        get-container="body"
        :style="{ height: '90%', width: '100%' }"
        :closeable="true"
      >
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            详情
          </div>
          <van-cell-group class="plr20">
            <van-cell title="气瓶编号" :value="showbottleList.bottleId||'-'" />
            <van-cell title="充装介质" :value="showbottleList.gasTypeName||'-'" />
            <van-cell title="入库时间" :value="showbottleList.incomingTime||'-'" />            
            <van-cell title="登记单位" :value="showbottleList.ownerDeptName||'-'" />
            <van-cell title="制造单位" :value="showbottleList.makerDept||'-'" />
            <van-cell title="出厂编号" :value="showbottleList.leaveFactoryNo||'-'" />
            <van-cell title="自有编号" :value="showbottleList.ownerNo||'-'" />
            <van-cell title="制造年月" :value="showbottleList.makeDate||'-'" />
            <van-cell title="末检年月" :value="showbottleList.lastCheckDate||'-'" />
            <van-cell title="下检年月" :value="showbottleList.nextCheckDate||'-' " />
            <van-cell title="报废年月" :value="showbottleList.scrapDate||'-'" />
            <van-cell title="气瓶种类" :value="showbottleList.bottleType||'-'" />            
            <van-cell title="气瓶规格" :value="showbottleList.bottleModel||'-'" />
          </van-cell-group>

          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="show = false"
              >关闭</van-button
            >
          </div>
        </div>
      </van-popup>
      <van-popup
        v-model="chuShow"
        get-container="body"
        :style="{ height: '90%', width: '100%' }"
        :closeable="true"
      >
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            详情
          </div>
          <van-cell-group class="plr20">
            <van-cell title="登记单位" :value="showChuList.ownerDeptName||'-'" />
            <van-cell title="气瓶编号" :value="showChuList.bottleId||'-'" />
            <van-cell title="填充介质" :value="showChuList.gasTypeName||'-'" />
            <van-cell title="气瓶责任人" :value="showChuList.auditerName||'-'" />
            <van-cell title="库存状态" :value="showChuList.stockStatus||'-'" />
            <van-cell title="下次检测日期" :value="showChuList.nextCheckDate||'-'" />
            
          </van-cell-group>
          <van-field name="uploader" label="上传图片" label-align="center" :required="false"
           :rules="[{ required: false, message: '请上传图片' }]">
            <template #input>
              <van-uploader :name="1" :after-read="afterRead" 
              :multiple="false" v-model="picList" />
            </template>
          </van-field>

          <div class="tc ptb10">
            <van-button type="info" class="tc" style="margin-right: 50px;" @click="handleChu"
              >处理</van-button
            >
            <van-button type="danger" class="tc" @click="chuShow = false"
              >取消</van-button
            >
          </div>
        </div>
      </van-popup>
      <van-tabs v-model="active" color="#4597ff" sticky @click="initContent">
        <van-tab title="预警处理">
          <div>
            <van-pull-refresh
              class="bggrey"
              v-model="isLoading"
              @refresh="onRefresh"
            >
              <div class="autoFixed">
                <van-list
                  v-model="loading"
                  :finished="finishedBottom"
                  finished-text="没有更多了"
                >
                  <van-cell
                    v-for="(item, index) in unHandleList"
                    :key="index"
                    style="margin-top: 20px; padding: 0"
                  >
                    <div class="main">
                      <div class="history-left" style="margin-top: 20px">
                        <div class="history-item">
                          <span>气瓶厂家：</span>
                          <span>{{ item.ownerDeptName }}</span>
                        </div>
                        <div class="history-item">
                          <span>气瓶编号：</span>
                          <span>{{ item.bottleId }}</span>
                        </div>
                        <div class="history-item">
                          <span>填充介质：</span>
                          <span>{{ item.gasTypeName }}</span>
                        </div>
                        <div class="history-item">
                          <span>责任人：</span>
                          <span>{{ item.auditerName }}</span>
                        </div>
                        <div class="history-item">
                          <span>库存状态：</span>
                          <span>{{ item.stockStatus }}</span>
                        </div>
                        <!-- <div v-if="item.borrowerName" class="history-item">
                          <span>领用人：</span>
                          <span>{{ item.borrowerName }}</span>
                        </div> -->
                        <div class="history-item">
                          <span>下次检测日期：</span>
                          <span>{{ item.nextCheckDate }}</span>
                        </div>
                      </div>
                      <van-button
                        plain
                        type="primary"
                        size="small"
                        class="userBtn1"
                        @click="goChu(item)"
                        >处理
                      </van-button>
                    </div>
                  </van-cell>
                </van-list>
              </div>
            </van-pull-refresh>
          </div>
        </van-tab>
        <van-tab title="处理历史">
          <div>
            <van-pull-refresh
              class="bggrey"
              v-model="isLoading"
              @refresh="onRefresh1"
            >
              <div class="autoFixed">
                <van-list
                  v-model="loading"
                  :finished="finishedBottom"
                  finished-text="没有更多了"
                >
                  <van-cell
                    v-for="(item, index) in handlehistoryList"
                    :key="index"
                    style="margin-top: 20px; padding: 0"
                  >
                    <div class="main">
                      <div class="history-left" style="margin-top: 20px">
                        <div class="history-item">
                          <span>气瓶厂家：</span>
                          <span>{{ item.ownerDeptName }}</span>
                        </div>
                        <div class="history-item">
                          <span>气瓶编号：</span>
                          <span>{{ item.bottleId }}</span>
                        </div>
                        <div class="history-item">
                          <span>填充介质：</span>
                          <span>{{ item.gasTypeName }}</span>
                        </div>
                        <div class="history-item">
                          <span>责任人：</span>
                          <span>{{ item.auditerName }}</span>
                        </div>
                        <div class="history-item">
                          <span>库存状态：</span>
                          <span>{{ item.stockStatus }}</span>
                        </div>
                        <div v-if="item.borrowerName" class="history-item">
                          <span>领用人：</span>
                          <span>{{ item.borrowerName }}</span>
                        </div>
                        <div class="history-item">
                          <span>下次检测日期：</span>
                          <span>{{ item.nextCheckDate }}</span>
                        </div>
                      </div>

                      <van-button
                        plain
                        type="primary"
                        size="small"
                        class="userBtn1"
                        @click="getDetailList(item.bottleUid)"
                        >详情
                      </van-button>
                    </div>
                  </van-cell>
                </van-list>
              </div>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { queryEarlyWarn, handleWarn,queryBottleDetail,uploadImg } from "@/apis/api";
import {  Toast } from "vant";
export default {
  data() {
    return {
      active: 0,
      isLoading: false,
      loading: false,
      finishedBottom: false,
      show: false,
      chuShow: false,
      handlehistoryList: [],
      unHandleList: [],
      showbottleList: {},
      showChuList: {},
      picker_car: "",
      picList: [],
      bottlePhoto: '',
      appForm: {
        gasType: "", //气体类型id
        gasTypeName: "", //气体类型名称
        auditer: "", // 审核人Id ,
        auditerName: "", // 审核人姓名 ,
        borrowCount: "", //领用个数 ,
        bottleList: [],
      },
      handle: 0,
    };
  },
  mounted() {
    document.title = "气瓶检测有效期预警";
    this.getList();
  },
  methods: {
    // 文件上传
			afterRead(file,params) {
				console.log(file);
				console.log(params);
				let code = params.name
				// let index = params.name.split(',')[1]
        console.log(code);
				// console.log(index);
				// 此时可以自行将文件上传至服务器
				if(Array.isArray(file)){
					for(let i =0;i<file.length;i++){
						file[i].file.status = 'uploading';
						file[i].file.message = '上传中...';
						uploadImg({
							img: file[i].content,
							openId: localStorage.getItem('openId'),
							ext: file[i].file.name.split('.')[1]
						}).then(res => {
							Toast('上传成功')
              this.bottlePhoto =res.result.savePath;
							file[i].file.status = 'done';
							file[i].file.message = '上传成功';
						})
					}
				}else{
					file.status = 'uploading';
					file.message = '上传中...';
					uploadImg({
						img: file.content,
						openId: localStorage.getItem('openId'),
						ext: file.file.name.split('.')[1]
					}).then(res => {
						Toast('上传成功')
            this.bottlePhoto =res.result.savePath;
						file.status = 'done';
						file.message = '上传成功';
					})
				}
			},
    // 处理弹窗
    goChu(item){
      this.chuShow = true;
      this.showChuList = item;
    },
    // 提交处理
    handleChu() {
      if (!this.bottlePhoto) {
        Toast('请上传图片')
      }
      this.showChuList.bottlePhoto = this.bottlePhoto
      
      console.log(this.showChuList);
      handleWarn(this.showChuList).then((res) => {
        if (res.code == 200) {
          this.$toast(res.message || "处理成功");
          this.chuShow = false;
          this.reset();
          //处理成功后刷新
          this.getList();
        } else {
          this.$toast(res.message || "提交失败");
        }
      });
    },
    reset(){
      this.showChuList = {};
      this.picList = [];
      this.bottlePhoto = {};
    },
    // 获取历史列表
    getDetailList(bottleId) {
      this.show = true;
      queryBottleDetail({
				bottleId: bottleId
			}).then(res => {
				if (res.code == 200) {
          this.showbottleList = res.result;
				} else {
					this.$toast(res.message);
				}
			})
    },
    // 获取预警列表
    getList(index) {
      this.isLoading = true;
      this.loading = true;
      queryEarlyWarn({
        handle:0
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index == 1) {
            Toast("刷新成功");
          }
          this.unHandleList = res.result;
          this.finishedBottom = true;
        } else {
          this.finishedBottom = true;
          this.$toast(res.message || "失败");
        }
      });
    },
    //预警列表刷新
    onRefresh() {
      this.getList(1);
    },
    // 获取历史列表
    getHistoryList(index) {
      this.isLoading = true;
      this.loading = true;
      queryEarlyWarn({handle:1}).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index == 1) {
            Toast("刷新成功");
          }
          this.handlehistoryList = res.result;
          this.finishedBottom = true;
        } else {
          this.finishedBottom = true;
          this.$toast(res.message || "失败");
        }
      });
    },
    //历史列表刷新
    onRefresh1() {
      this.getHistoryList(1);
    },

    // tab点击
    initContent(value) {
      this.active = value;
      if (value == 0) {
        this.getList();
      } else {
        this.getHistoryList();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pages {
  background: #f8f8f8;
  min-height: 100vh;
}
.history {
  padding: 16px;
  background: #f8f8f8;

  .his-wrapper {
    background: #fff;
    border-radius: 6px;
    padding: 10px;
    position: relative;
    margin-bottom: 10px;

    .audits {
      position: absolute;
      right: 40px;
      top: 70%;
      transform: translateY(-70%);
      font-size: 30px;
      color: green;
    }

    .lsits {
      position: absolute;
      right: 20px;
      top: 20px;
      height: 40px;
    }
  }
}
.autoFixed {
 background: #f3f3f3;
 min-height: 100vh;
 padding:0 20px;
 position: relative;
//  .userBtn {
//    position: absolute;
//    right: 20px;
//    top: 20px;
//    width: 94px;
//    height: 40px;
//    text-align: center;
//    line-height: 40px;
//    background: none;
//    border-radius: 5px;
//    color: #4597FF;
//  }
 .userBtn1 {
   position: absolute;
   right: 20px;
   top: 25px;
   width: 94px;
   height: 40px;
   text-align: center;
   line-height: 40px;
   background: none;
   border-radius: 5px;
   color: #55aa7f;
 }

 .main {
   box-sizing: content-box;
   background: #ffffff;
   display: flex;
   justify-content: space-between;
   align-items: flex-end;
   width: 100%;
   border-radius: 5px;
   padding:0 24px;
   box-sizing: border-box;
   position: relative;


   .history-item {
     margin-bottom: 15px;

     span {
       font-size: 28px;
       color: #333;
     }
   }
 }
}



.itme-wrapper {
  padding: 16px;
  height: 50vh;
  // background: red;
  overflow: scroll;

  .items {
    height: 50px;
    background: #ccc;
    padding: 0 10px;
    line-height: 50px;
  }
}

</style>
